exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-87c7fc80] .v-datatable.v-table>thead tr{background-color:#ddd;height:40px}.box-circle-counter>div[data-v-87c7fc80]{margin-right:auto;margin-left:auto}.box-circle-counter p[data-v-87c7fc80]{text-align:center;font-weight:600}", ""]);

// exports
